import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import { ButtonLink, Flex, Heading, Text, Tooltip } from '@applyboard/crystal-ui';
import { useEventTracker } from '@applyboard/ui-utils';
import { SuggestedContent, SuggestedItemContainer, SuggestionBlock, SuggestionGroup, SuggestionLabel, SuggestionResultContainer, SuggestionScoreContainer } from "../style";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var getColorForVisaScore = function getColorForVisaScore(score) {
  if (score < 25) {
    return '#BE0E31';
  }
  if (score < 50) {
    return '#BC7100';
  }
  if (score < 75) {
    return '#0064E1';
  }
  return '#148750';
};
export var SuggestionItem = function SuggestionItem(_ref) {
  var province = _ref.province,
    levelOfStudy = _ref.levelOfStudy,
    score = _ref.score,
    isTopScore = _ref.isTopScore,
    _ref$quickSearchProgr = _ref.quickSearchProgramLevels,
    quickSearchProgramLevels = _ref$quickSearchProgr === void 0 ? [] : _ref$quickSearchProgr,
    isSupportedLevel = _ref.isSupportedLevel,
    index = _ref.index;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var generateSearchURL = function generateSearchURL() {
    var params = new URLSearchParams();
    if (province) {
      // province needs to be turned from e.g. Prince Edward Island -> prince-edward-island
      params.append('filter[locations]', "ca:".concat(province.toLowerCase().split(' ').join('-')));
    } else {
      params.append('filter[locations]', 'ca');
    }
    params.append('filter[program_levels]', quickSearchProgramLevels.join(','));
    return "/search?".concat(params.toString());
  };
  var onFindPrograms = function onFindPrograms() {
    trackEvent({
      data: {
        Score: score,
        'Level of study': levelOfStudy,
        'Destination Province': province,
        'Button Number': index + 1
      },
      event: "Visa Services - Results - Clicked Find Programs CTA",
      group: 'Returned Results'
    });
  };
  return _jsx(SuggestedItemContainer, {
    children: _jsxs(SuggestedContent, {
      children: [_jsxs(SuggestionResultContainer, {
        children: [_jsx(SuggestionScoreContainer, {
          isTopScore: isTopScore,
          children: _jsx(Heading, {
            level: 3,
            children: _jsx("div", {
              style: {
                color: getColorForVisaScore(score)
              },
              children: "".concat(score, "%")
            })
          })
        }), _jsxs(SuggestionGroup, {
          children: [_jsxs(SuggestionBlock, {
            children: [_jsx(SuggestionLabel, {
              children: _jsx(Text, {
                variant: "labelM",
                children: "Level of study"
              })
            }), _jsx(Text, {
              variant: "bodyM",
              children: levelOfStudy
            })]
          }), _jsxs(SuggestionBlock, {
            children: [_jsx(SuggestionLabel, {
              children: _jsx(Text, {
                variant: "labelM",
                children: "Province"
              })
            }), _jsx(Text, {
              variant: "bodyM",
              children: province
            })]
          })]
        })]
      }), _jsxs(Flex, {
        direction: "row",
        align: "center",
        gap: 4,
        children: [_jsx(ButtonLink, {
          mode: "override_user_choice_and_open_in_new_tab",
          href: generateSearchURL(),
          intent: "primary",
          emphasis: isTopScore ? 'contained' : 'transparent',
          onClick: onFindPrograms,
          children: "Find Programs"
        }), !isSupportedLevel && _jsx(Tooltip, {
          label: "ApplyBoard currently does not offer this program level, click to explore other great options",
          children: _jsx(Tooltip.Icon, {
            intent: "warning"
          })
        })]
      })]
    })
  });
};